import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { LinkItUrl, LinkIt } from 'react-linkify-it';

const UnderwriteNotes = ({ classes, notes }) => {
  const zillowRegex = /(((ht|f)tp(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}\.[a-zA-Z]{2,}(([^\s]+\/[^\s]+)?([a-zA-Z0-9\s._,?+&\-\\;'"%$#!@~(){}\[\]*]+[^\s\w]))[^\s\/^\s]*/g;  // regex for urls with spaces and ends with '/'
  const nonZillowRegex = /(((ht|f)tp(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}\.[a-zA-Z]{2,}(([^\s]+\/[^\s]+)?([a-zA-Z0-9\s._,?+&\-\\;'"%$#!@~(){}\[\]*]+))[^\s\/^\s]*\^\s/g; 
  const regexToMatch = notes.indexOf("zillow.com") !== -1 ? zillowRegex : nonZillowRegex;
  return (
    <div className={classes.containerClass} >
      <Typography variant='subtitle2'>Notes</Typography>      
      <LinkIt component={(match, key) => <a href={match} key={key} target='_blank'>{match}</a>} // Create links for urls with spaces, LinkItUrl create links for all other urls
        regex={regexToMatch}>
        <LinkItUrl option={{target: '_blank'}}> 
          <div className={classes.notes}>{notes || 'No description'}</div>
        </LinkItUrl>
      </LinkIt>      
    </div>
  )
}

const styles = theme => ({
  containerClass: {
    // height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  notes: {
    overflowY: 'auto'
  }
});
const mapStateToProps = (state) => ({
})
const mapDispatchToProps = (dispatch) => ({
})
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(UnderwriteNotes);